import secureLocalStorage from "react-secure-storage"
import { AppEvents, StorageKeys } from "@utils/user-config"

export const setGlobalLocale = (locale: string) => {
	secureLocalStorage.setItem(StorageKeys.USER_PREFERRED_LANGUAGE, locale)
	window.dispatchEvent(
		new CustomEvent(AppEvents.USER_LANGUAGE_CHANGED, {
			detail: { locale }
		})
	)
}
